/* eslint-disable max-len */
import moment from 'moment';
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import NewCalenderIcon from '../../svgs/NewCalenderIcon';
import { dateFormatter } from '../../utils/helpers';
import StyledButton from '../StyledButton';
import Styles from './FilterPeriod.module.scss';

type IFilterPeriod = {
  from?: string;
  to?: string;
  fromDateTable?:string;
  toDateTable?:string;
  setFrom?: any;
  setTo?: any;
  setFilters?: any;
  label?: string;
  type?:string;
  fromDate?: string;
  toDate?: string;
  setFromDate?: any;
  setToDate?: any;
  submitFilters?:any;
  filterObj?:any
  isThisWeek?:boolean
  setToDateTable?:any;
  setFromDateTable?:any;
  setDateLabel?:any;
}
const FilterPeriod = ({
  from, to, setFrom, setTo, fromDate, toDate, fromDateTable, toDateTable, setFromDate, setToDate, type, setFilters, filterObj, setFromDateTable, setToDateTable, setDateLabel,
}: IFilterPeriod) => {
  // const currentDate = new Date();

  // // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  // const currentDayOfWeek = currentDate.getDay();

  // // Calculate the difference between the current day and the start of the week (Sunday)
  // const diff = currentDayOfWeek === 0 ? 0 : currentDayOfWeek - 1;

  const [activeDate, setActiveDate] = useState({
    label: '1 Year',
    to: dateFormatter(new Date(new Date().setDate(new Date().getDate())), 'YYYY-MM-DD'),
    from: dateFormatter(new Date(new Date().setDate(new Date().getDate() - 365)), 'YYYY-MM-DD'),
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showDropdown, setShowDropdown] = useState(false);

  const filterRef = useRef<HTMLDivElement>(null);

  const handleClickBtn = (e) => {
    if (filterRef?.current?.contains(e.target)) {
      return;
    }
    setShowDropdown(false);
  };
  useEffect(() => {
    window.addEventListener('click', handleClickBtn);
    return () => {
      window.removeEventListener('click', handleClickBtn);
    };
  }, []);

  const dateOptions = [
    {

      label: 'This week',
      to: moment().endOf('week').format('YYYY-MM-DD'),
      from: moment().startOf('week').format('YYYY-MM-DD'),
    },

    {
      label: 'Last 7 Days',
      to: dateFormatter(new Date(new Date().setDate(new Date().getDate())), 'YYYY-MM-DD'),
      from: dateFormatter(new Date(new Date().setDate(new Date().getDate() - 7)), 'YYYY-MM-DD'),
    },
    {
      label: 'Last 30 Days',
      to: dateFormatter(new Date(new Date().setDate(new Date().getDate())), 'YYYY-MM-DD'),
      from: dateFormatter(new Date(new Date().setDate(new Date().getDate() - 30)), 'YYYY-MM-DD'),
    },
    {
      label: '1 Year',
      to: dateFormatter(new Date(new Date().setDate(new Date().getDate())), 'YYYY-MM-DD'),
      from: dateFormatter(new Date(new Date().setDate(new Date().getDate() - 365)), 'YYYY-MM-DD'),
    },
  ];

  useMemo(() => {
    if (type === 'alternativeDateRange') {
      setFilters((prev) => ({
        ...prev,
        fromDate: dateOptions[3]?.from,
        toDate: dateOptions[3]?.to,
      }));
      return;
    }
    if (type === 'tableDateRange') {
      setFilters((prev) => ({
        ...prev,
        fromDateTable: dateOptions[3]?.from,
        toDateTable: dateOptions[3]?.to,
      }));
      return;
    }
    setFilters((prev) => ({
      ...prev,
      from: dateOptions[3]?.from,
      to: dateOptions[3]?.to,
    }));
  }, [type]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const formatDateToLabel = (dateLable:string) => {
    switch (dateLable) {
    case 'This week':

      return setDateLabel({
        value: 'THIS_WEEK',
        label: dateLable,
      });
    case 'Last 7 Days':

      return setDateLabel({
        value: 'LAST_7_DAYS',
        label: dateLable,
      });
    case 'Last 30 Days':

      return setDateLabel({
        value: 'THIS_MONTH',
        label: dateLable,
      });
    case '1 Year':

      return setDateLabel({
        value: 'THIS_YEAR',
        label: dateLable,
      });
    default:
      return setDateLabel({
        value: 'THIS_YEAR',
        label: dateLable,
      });
    }
  };

  useEffect(() => {
    if (from || to) {
      filterObj?.submitFilters();
    }
    if (fromDate || toDate) {
      filterObj?.submitFilters();
    }
    if (toDateTable || fromDateTable) {
      filterObj?.submitFilters();
    }
  }, [from, to, toDate, fromDate, type, fromDateTable, toDateTable]);

  const handleClick = (rest:any) => {
    setActiveDate(rest);
    setShowDropdown(false);
    if (type === 'alternativeDateRange') {
      setFromDate(rest.fromDate);

      setToDate(rest.toDate);
      setFilters((prev) => ({
        ...prev,
        fromDate: rest?.from,
        toDate: rest?.to,
      }));
      formatDateToLabel(rest?.label);
      return;
    }
    if (type === 'tableDateRange') {
      setFromDateTable(rest.fromDateTable);
      setToDateTable(rest.toDateTable);
      setFilters((prev) => ({
        ...prev,
        fromDateTable: rest?.from,
        toDateTable: rest?.to,
      }));
      return;
    }

    setFrom(rest.from);
    setTo(rest.to);
    setFilters((prev) => ({
      ...prev,
      from: rest?.from,
      to: rest?.to,
    }));
    formatDateToLabel(rest?.label);
  };

  return (
    <div className={Styles.wrapper} ref={filterRef}>
      <StyledButton name={activeDate?.label} border="none" fontSize="10px" padding="10px 8px" fontWeight="600" backgroundColor="white" boxShadow="0px 0px 10px 0px #20202014" icon={<NewCalenderIcon />} onClick={() => setShowDropdown(!showDropdown)} borderRadius="8px" />
      {
        showDropdown && (
        <div className={Styles.wrapper__dropdownContainer}>
          { dateOptions?.map(({ ...rest }: any) => (
            <div
              onClick={() => handleClick(rest)}
              className={` ${Styles.wrapper__dropdownList} ${(from === rest.from || fromDate === rest?.from || fromDateTable === rest?.from) && (to === rest.to || toDate === rest?.to || toDateTable === rest?.to) ? Styles.wrapper__selectedList : ''}`}
              key={rest?.label}
            >
              {rest?.label}
            </div>
          ))}
        </div>
        )
      }

    </div>
  );
};

export default FilterPeriod;
